import { pushToDataLayer } from '../../../../../services/gtmService';

import {
  calculateTimeSpentInMilliseconds,
  removeStartTime,
} from '../../../../../helpers/browserStorageTimer';

import { FINANCE_APPLICATION_START_TIME } from '../../../constants';

import { type ApplicationTrackingArgs, RESULT } from './tracking.typed';

export const onSubmitTrackingEvent = (args: ApplicationTrackingArgs) => {
  const { result, provider, errorFields = null } = args;
  const time =
    calculateTimeSpentInMilliseconds(FINANCE_APPLICATION_START_TIME) / 1000;

  if (result === RESULT.SUCCESS) {
    pushToDataLayer({
      event: 'finance_application_submitted',
      time,
      finance_provider: provider,
    });
    removeStartTime(FINANCE_APPLICATION_START_TIME);
  } else {
    pushToDataLayer({
      event: 'finance_application_error',
      error_fields: errorFields,
      time,
      finance_provider: provider,
    });
  }
};
